export default __webpack_public_path__ + "static/media/shareIcon.e41536ed.svg";